import { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import ImageCropperBanner from "./ImageCropperBanner";
import { API } from "../../../../../api/URL_API";

function ModalBanner({ show, onHide, onSuccess, initialData }) {
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [rawImage, setRawImage] = useState(null);
  const [showCropper, setShowCropper] = useState(false);

  useEffect(() => {
    if (initialData) {
      setPreview(initialData.imageUrl);
      setLink(initialData.link);
      setImageFile(null);
    } else {
      resetForm();
    }
  }, [initialData, show]);

  const resetForm = () => {
    setImageFile(null);
    setPreview("");
    setLink("");
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setRawImage(file);
    setShowCropper(true);
  };

  const handleCroppedImage = (file) => {
    setImageFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!link) {
      Swal.fire({
        icon: "warning",
        title: "Campo obligatorio",
        text: "Debes ingresar un link de redirección",
        confirmButtonColor: "#dc3545",
        iconColor: '#da292e',
      });
      return;
    }

    const formData = new FormData();
    formData.append("link", link);

    if (imageFile) {
      formData.append("image", imageFile);
    }

    // 🔍 DEPURACIÓN
    //console.log("🚀 Enviando banner:");
    //console.log("➡️ Modo:", initialData ? "PUT (editar)" : "POST (crear)");
    //console.log("➡️ link:", link);
    //console.log("➡️ imageFile:", imageFile);

    try {
      setLoading(true);

      let response;

      if (initialData) {
        // 🔁 EDITAR
        response = await axios.put(
          `${API}/api/banners/${initialData.idBanner}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      } else {
        // ➕ CREAR
        response = await axios.post(
          `${API}/api/banners`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      }

      Swal.fire({
        icon: "success",
        title: initialData ? "Banner actualizado" : "Banner creado",
        text: "La operación se realizó correctamente",
        timer: 2000,
        showConfirmButton: false,
        iconColor: '#2fb380',
      });

      //console.log("✅ Respuesta backend:", response.data);

      onSuccess && onSuccess();
      resetForm();
      onHide();
    } catch (error) {
      console.error("❌ Error guardando banner:", error.response || error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "Ocurrió un error al guardar el banner",
        confirmButtonColor: "#dc3545",
        iconColor: '#da292e',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {initialData ? "Editar Banner" : "Nuevo Banner"}
          </Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Imagen del banner</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                required={!initialData}
              />
            </Form.Group>

            {preview && (
              <div className="mb-3 text-center">
                <img
                  src={preview}
                  alt="preview"
                  className="img-fluid rounded"
                  style={{ maxHeight: "200px" }}
                />
              </div>
            )}

            <Form.Group>
              <Form.Label>Link de redirección</Form.Label>
              <Form.Control
                type="text"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                placeholder="nombre de categoria ej: california"
                required
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="dark" onClick={onHide} disabled={loading}>
              Cancelar
            </Button>
            <Button type="submit" variant="danger" disabled={loading}>
              {loading ? <Spinner size="sm" /> : "Guardar"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <ImageCropperBanner
        show={showCropper}
        imageFile={rawImage}
        onSave={handleCroppedImage}
        onClose={() => setShowCropper(false)}
      />
    </>
  );
}

export default ModalBanner;
